export enum TOUR_ACTION_TYPES {
  FETCH_TOUR_START = "tour/FETCH_TOUR_START",
  FETCH_TOUR_SUCCESS = "tour/FETCH_TOUR_SUCCESS",
  FETCH_TOUR_FAILED = "tour/FETCH_TOUR_FAILED",
}
